<section class="container-style">
  <form [formGroup]="formDeleteCompany" autocomplete="off">
    <!-- Warning -->
    <div class="row mb-2">
      <div class="col-12">
        <div class="alert alert-warning d-flex align-items-start" role="alert">
          <i class="pi pi-exclamation-triangle me-2 mt-1"></i>
          <div>
            <strong>Advertencia:</strong> Esta acción eliminará permanentemente la compañía y toda su información
            asociada.<br />
            <!-- <small>Esta operación no se puede deshacer.</small> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-4 col-6 mb-1">
        <app-custom-input-text formControlName="document" [labelText]="'NIT de la compañía'" autocomplete="off">
        </app-custom-input-text>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-4 col-6 mb-1">
        <app-custom-input-password formControlName="passwordHash" [labelText]="'Contraseña'" [required]="true"
          [visibleDescription]="false" autocomplete="new-password" [appendTo]="'body'">
        </app-custom-input-password>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-sm-2 mt-md-3">
        <app-custom-button [label]="'Confirmar eliminación'" [severity]="'danger'" [width]="'10rem'"
          [variant]="undefined" (onClick)="send()">
        </app-custom-button>
      </div>
    </div>

  </form>
</section>